import toast from "react-hot-toast"

type SuccessToastArgs = Parameters<typeof toast.success>
export const successToast = (message: SuccessToastArgs[0], args?: SuccessToastArgs[1]) => {
  return toast.success(message, args)
}
